

export const mapESanchitDetails = (resp) => ({
  id: resp.exporteSanchitId,
  eSanchitDocumentLevel: resp.eSanchitDocumentLevel || " ",
  eSanchitInvsrNo: resp.eSanchitInvsrNo || "",
  eSanchitItemSrNo: resp.eSanchitItemSrNo || "",
  eSanchitScope: resp.eSanchitScope || "",
  eSanchitIRN: resp.eSanchitIRN || "",
  eSanchitDocumentType: resp.eSanchitDocumentType || "",
  eSanchitAttachmentId:resp.eSanchitAttachmentId ?? null,
  eSanchitAttachment:resp.eSanchitAttachment ?? null,
  eSanchitDocumentRefNo: resp.eSanchitDocumentRefNo || "",
  eSanchitIcegateId: resp.eSanchitIcegateId || "",
  eSanchitOtherIcegateId:resp.eSanchitOtherIcegateId||"",
  eSanchitIRN:resp.eSanchitIRN||"",
  eSanchitDocumentRefNo:resp.eSanchitDocumentRefNo|| "",
  eSanchitDateofIssue: resp.eSanchitDateofIssue || "",
  eSanchitExpiryDate: resp.eSanchitExpiryDate || "",
  eSanchitPlaceofIssue: resp.eSanchitPlaceofIssue || "",
  eSanchitDatetimeupload: resp.eSanchitDatetimeupload || "",
  eSanchitICegateFileName: resp.eSanchitICegateFileName || "",
  eSanchitFileType: resp.eSanchitFileType || "",
  eSanchitIssuingName: resp.eSanchitIssuingName || "",
  eSanchitbeneficiaryName: resp.eSanchitbeneficiaryName || "",
  eSanchitIssuingcode: resp.eSanchitIssuingcode || "",
  eSanchitbeneficiarycode: resp.eSanchitbeneficiarycode || "",
  eSanchitIssuingAddressLine1: resp.issuingCustomerAddressLine1 || "",
  eSanchitbeneficiaryAddressLine1: resp.beneficiaryCustomerAddressLine1 || "",
  eSanchitIssuingAddressLine2: resp.issuingCustomerAddressLine2 || "",
  eSanchitbeneficiaryAddressLine2: resp.beneficiaryCustomerAddressLine2 || "",
  eSanchitIssuingCityName: resp.issuingCustomerCityName || "",
  eSanchitbeneficiaryCityName: resp.beneficiaryCustomerCityName || "",
  eSanchitIssuingpincode: resp.issuingCustomerPostalCode || "",
  eSanchitbeneficiarypincode: resp.beneficiaryCustomerPostalCode || "",
});





